import api from "./apiClient";
import { Relay } from "../types/Relay";

export const RelayService = {
  async getRelay(): Promise<Relay> {
    try {
      const response = await api.get<Relay>("api/get-relay");
      return response.data;
    } catch (error) {
      console.error("error fetching relay data: ", error);
      throw error;
    }
  },
};
